var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`px-3 py-1 d-flex justify-space-between ${
			_vm.post.delReason ? 'red lighten-1 white--text' : 'grey lighten-3'
		}`},[_c('div',{staticClass:"no-flex"},[_vm._v(_vm._s(_vm.post.delReason ? _vm.post.delReason.S : ""))]),_c('timeago',{staticClass:"body-1 no-flex",attrs:{"datetime":_vm._getPostedDate(_vm.post.postedOn.N)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }